import React from "react";
import { Box, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { S3Storage } from "../../../../../types/targetStorageTypes";
import { SOCIAL_ACCOUNT_BUTTON_WIDTH } from "../../../../../constants/styles";

interface StorageFormProps {
    account: any;
    mode: 'readonly' | 'updatable';
    onFieldChange: (field: string, value: any) => void;
    onCreate: () => void;
    onUpdate: () => void;
    onDelete: () => void;
    onChangeMode: (mode: 'readonly' | 'updatable') => void;
}

const S3StorageForm: React.FC<StorageFormProps> = ({ account, mode, onFieldChange, onCreate, onUpdate, onDelete, onChangeMode }) => {
    const s3Account = account as S3Storage;
    const isReadonly = mode === 'readonly';

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField fullWidth label="Name" value={s3Account.name} disabled={isReadonly} onChange={(e) => onFieldChange('name', e.target.value)} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField fullWidth label="Bucket Name" value={s3Account.bucket_name} disabled={isReadonly} onChange={(e) => onFieldChange('bucket_name', e.target.value)} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField fullWidth label="Region" value={s3Account.region} disabled={isReadonly} onChange={(e) => onFieldChange('region', e.target.value)} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField fullWidth label="Prefix (Optional)" value={s3Account.prefix} disabled={isReadonly} onChange={(e) => onFieldChange('prefix', e.target.value)} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        label="Access Key"
                        type="password"
                        value={isReadonly ? (s3Account.id ? '********' : '') : (s3Account.access_key || '')}
                        disabled={isReadonly}
                        onChange={(e) => onFieldChange('access_key', e.target.value)}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        label="Secret Key"
                        type="password"
                        value={isReadonly ? (s3Account.id ? '********' : '') : (s3Account.secret_key || '')}
                        disabled={isReadonly}
                        onChange={(e) => onFieldChange('secret_key', e.target.value)}
                    />
                </Grid>
            </Grid>
            <Box sx={{ mt: 2, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                {isReadonly ? (
                    <>
                        <Button variant="contained" sx={{width: SOCIAL_ACCOUNT_BUTTON_WIDTH}} startIcon={<DeleteIcon />} onClick={onDelete}>Delete</Button>
                        <Button variant="contained" sx={{width: SOCIAL_ACCOUNT_BUTTON_WIDTH}} startIcon={<EditIcon />} onClick={() => onChangeMode('updatable')}>Edit</Button>
                    </>
                ) : (
                    <>
                        {s3Account.id && <Button variant="contained" sx={{width: SOCIAL_ACCOUNT_BUTTON_WIDTH}} startIcon={<CloseIcon />} onClick={() => onChangeMode('readonly')}>Cancel</Button>}
                        <Button variant="contained" sx={{width: SOCIAL_ACCOUNT_BUTTON_WIDTH}} startIcon={<SaveIcon />} onClick={s3Account.id ? onUpdate : onCreate}>
                            {s3Account.id ? 'Save' : 'Create'}
                        </Button>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default S3StorageForm;